import * as zlib from 'browserify-zlib';
import { logger } from 'logging-utils';

export const parseBlob = async <T>(blob: string): Promise<T | undefined> => {
  const uncompressed = await uncompressReport(blob);
  if (!uncompressed) {
    logger.error('Failed to report parseBlob - empty data');
    return;
  }
  return JSON.parse(uncompressed);
};

const uncompressReport = async (blob: string): Promise<string | null> => {
  try {
    const result = await uncompress(blob);
    return result;
  } catch (err) {
    logger.error('Failed to uncompress report data', err);
    return null;
  }
};

const uncompress = (base64: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    zlib.unzip(Buffer.from(base64, 'base64'), (err, _buffer) => {
      if (err) reject(err);
      resolve(_buffer?.toString());
    });
  });
};
